<template>
    <div class="mt-[24px] mx-[24px]">
        <PrimeTabs :value="selectedTab">
            <PrimeTabList class="w-full flex justify-between">
                <PrimeTab value="0" class="sm:w-1/2 w-auto">Scan Activity</PrimeTab>
                <PrimeTab 
                    value="1" 
                    class="sm:w-1/2 w-auto rapid-response-tab"
                    @click="handleRapidResponseTabClick"
                >
                    Rapid Response Escalation
                </PrimeTab>
            </PrimeTabList>
            <PrimeTabPanels>
                <PrimeTabPanel value="0">
                    <ScanActivityTab />
                </PrimeTabPanel>
                <PrimeTabPanel value="1">
                    <!-- <RapidResponseEscalationTab v-if="hasSignatureLicense || hasSignatureLicense === null" /> -->
                    <div class="coming-soon-panel">
                        <div class="text-center py-8">
                            <div class="mb-4">
                                <svg class="w-12 h-12 mx-auto text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                            </div>
                            <h3 class="text-lg font-medium text-gray-900 mb-2">Coming Very Soon</h3>
                            <p class="text-gray-600">Rapid Response Escalation features are being finalized and will be available soon.</p>
                        </div>
                    </div>
                    <!-- <div v-else class="license-required-panel">
                        <div class="text-center py-8">
                            <div class="mb-4">
                                <svg class="w-12 h-12 mx-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                                </svg>
                            </div>
                            <h3 class="text-lg font-medium text-gray-900 mb-2">Signature Services Required</h3>
                            <p class="text-gray-600 mb-4">{{ licenseStatusMessage }}</p>
                            <button 
                                @click="openUpgradeDialog"
                                class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium"
                            >
                                {{ person?.licenses?.some(license => !license.expired) ? 'Upgrade License' : 'Purchase License' }}
                            </button>
                        </div>
                    </div> -->
                </PrimeTabPanel>
            </PrimeTabPanels>
        </PrimeTabs>
    </div>
</template>
<script setup lang="ts">
import PrimeTab from 'primevue/tab';
import PrimeTabList from 'primevue/tablist';
import PrimeTabPanel from 'primevue/tabpanel';
import PrimeTabPanels from 'primevue/tabpanels';
import PrimeTabs from 'primevue/tabs';
import ScanActivityTab from '~/components/side-bar/person/ScanActivityTab.vue';
import { useExposureSidebarStore } from '~/stores/components/modals/exposure-sidebar';
import { usePersonStore } from '~/stores/person';
import { PurchaseType } from '~/types/licenses/licenses';
import { ModalNames } from '~/types/modals';

const selectedTab = ref('0');

// Get license status from the exposure sidebar store
const exposureSidebarStore = useExposureSidebarStore();
const { hasSignatureLicense, licenseStatusMessage } = storeToRefs(exposureSidebarStore);

// Get person store to check for existing licenses
const personStore = usePersonStore();
const { person } = storeToRefs(personStore);

function handleRapidResponseTabClick() {
    // Allow normal tab switching for licensed users
    selectedTab.value = '1';
}

function openUpgradeDialog() {
    // Check if user has any active licenses
    const hasAnyActiveLicense = person.value?.licenses?.some(license => !license.expired) || false;
    
    if (hasAnyActiveLicense) {
        // User has licenses but not signature - open upgrade modal
        useDynamicDialog(ModalNames.PURCHASE_LICENSES, {
            type: PurchaseType.UPGRADE,
        });
    } else {
        // User has no active licenses - open purchase modal
        useDynamicDialog(ModalNames.PURCHASE_LICENSES, {
            type: PurchaseType.PURCHASE,
        });
    }
}
</script>
<style scoped>
.prime-tab-list {
    display: flex !important;
    justify-content: space-between !important;
    width: 100% !important;
}

.disabled-tab {
    opacity: 0.6;
    cursor: pointer !important;
}

.disabled-tab:hover {
    background-color: rgba(59, 130, 246, 0.1) !important;
    opacity: 0.8;
}

.license-required-panel {
    padding: 1rem;
    background-color: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    margin-top: 1rem;
}

.coming-soon-panel {
    padding: 1rem;
    background-color: #eff6ff;
    border: 1px solid #dbeafe;
    border-radius: 0.5rem;
    margin-top: 1rem;
}
</style>
